export const quotesScheduleRoutes = { schedule: { proxy: 'quotes/schedule', upstream: 'v2/schedule/day' } } as const;
